import React, { useState, useEffect, Fragment } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Select from "react-select";
import API from "../../../services/API";

const ListAmalanBurukPage = () => {
  const [badDeeds, setBadDeeds] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [deedToEdit, setDeedToEdit] = useState(null);
  const [deedToDelete, setDeedToDelete] = useState(null);

  // Form fields
  const [mainCategory, setMainCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [description, setDescription] = useState("");
  const [severity, setSeverity] = useState("medium");
  const [isActive, setIsActive] = useState(true);

  // Edit form
  const [editMainCategory, setEditMainCategory] = useState("");
  const [editSubCategory, setEditSubCategory] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editSeverity, setEditSeverity] = useState("medium");
  const [editIsActive, setEditIsActive] = useState(true);

  const tokenHeader = {
    "Content-Type": "application/json",
    Accept: "application/json",
    token: localStorage.getItem("token"),
  };

  // ======== FETCH FUNCTIONS ========
  const fetchCategories = async () => {
    try {
      const resp = await API.get("/badDeeds/category/list", { headers: tokenHeader });
      if (resp.data.response_code === 1000) {
        setBadDeeds(resp.data.data || []);
      } else {
        setBadDeeds([]);
      }
    } catch (e) {
      setBadDeeds([]);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // ======== ADD CATEGORY ========
  const handleAddCategory = async () => {
    if (!mainCategory) {
      toast.error("Main category is required.");
      return;
    }
    try {
      const payload = {
        main_category: mainCategory,
        sub_category: subCategory,
        description,
        severity,
        is_active: isActive,
      };
      const resp = await API.post("/badDeeds/category/createOrUpdate", payload, {
        headers: tokenHeader,
      });
      if (resp.data.response_code === 1000) {
        toast.success("Category added successfully.");
        setIsAddModalOpen(false);
        fetchCategories();
      } else {
        toast.error(resp.data.message);
      }
    } catch (e) {
      toast.error("Error adding category.");
    }
  };

  // ======== EDIT CATEGORY ========
  const handleEditCategory = async () => {
    if (!deedToEdit) return;
    try {
      const payload = {
        main_category: editMainCategory,
        sub_category: editSubCategory,
        description: editDescription,
        severity: editSeverity,
        is_active: editIsActive,
      };
      const resp = await API.post("/badDeeds/category/createOrUpdate", payload, {
        headers: tokenHeader,
      });
      if (resp.data.response_code === 1000) {
        toast.success("Category updated successfully.");
        setIsEditModalOpen(false);
        fetchCategories();
      } else {
        toast.error(resp.data.message);
      }
    } catch (e) {
      toast.error("Error updating category.");
    }
  };

  // ======== DELETE CATEGORY ========
  const handleDeleteCategory = async () => {
    if (!deedToDelete) return;
    try {
      const resp = await API.delete(`/badDeeds/category/delete?category_id=${deedToDelete.id}`, {
        headers: tokenHeader,
      });
      if (resp.data.response_code === 1000) {
        toast.success("Category deleted successfully.");
        setIsDeleteModalOpen(false);
        fetchCategories();
      } else {
        toast.error(resp.data.message);
      }
    } catch (e) {
      toast.error("Error deleting category.");
    }
  };

  // ======== TABLE CONFIG ========
  const columns = [
    {
      name: "Main Category",
      selector: (row) => row.main_category,
      sortable: true,
      wrap: true,
    },
    {
      name: "Sub Category",
      selector: (row) => row.sub_category || "-",
      wrap: true,
    },
    {
      name: "Description",
      selector: (row) => row.description || "-",
      wrap: true,
      grow: 2,
    },
    {
      name: "Severity",
      selector: (row) => row.severity,
      center: true,
    },
    {
      name: "Active",
      selector: (row) => (row.is_active ? "Yes" : "No"),
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <div style={{ display: "flex", gap: 8 }}>
          <button
            className="btn btn-warning btn-sm"
            onClick={() => {
              setDeedToEdit(row);
              setEditMainCategory(row.main_category);
              setEditSubCategory(row.sub_category || "");
              setEditDescription(row.description || "");
              setEditSeverity(row.severity || "medium");
              setEditIsActive(row.is_active);
              setIsEditModalOpen(true);
            }}
          >
            Edit
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              setDeedToDelete(row);
              setIsDeleteModalOpen(true);
            }}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  // ======== RENDER ========
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="card rounded-25">
          <div className="card-header rounded-25 text-red d-flex justify-content-between align-items-center">
            <h5>Masalah Disiplin Category Management</h5>
            <button className="btn btn-primary" onClick={() => setIsAddModalOpen(true)}>
              Add Category
            </button>
          </div>
          <div className="card-body">
            <DataTable columns={columns} data={badDeeds} striped persistTableHead noHeader />
          </div>
        </div>
      </div>

      {/* ADD MODAL */}
      <Modal isOpen={isAddModalOpen} toggle={() => setIsAddModalOpen(false)}>
        <ModalHeader toggle={() => setIsAddModalOpen(false)}>Add Category</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Main Category</label>
            <input
              type="text"
              className="form-control"
              value={mainCategory}
              onChange={(e) => setMainCategory(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Sub Category</label>
            <input
              type="text"
              className="form-control"
              value={subCategory}
              onChange={(e) => setSubCategory(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Severity</label>
            <Select
              options={[
                { label: "Low", value: "low" },
                { label: "Medium", value: "medium" },
                { label: "High", value: "high" },
              ]}
              value={{ label: severity, value: severity }}
              onChange={(opt) => setSeverity(opt.value)}
            />
          </div>
          <div className="form-group">
            <label>Active?</label>
            <Select
              options={[
                { label: "Active", value: true },
                { label: "Inactive", value: false },
              ]}
              value={isActive ? { label: "Active", value: true } : { label: "Inactive", value: false }}
              onChange={(opt) => setIsActive(opt.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="dark" onClick={handleAddCategory}>
            Add Category
          </Button>
          <Button color="secondary" onClick={() => setIsAddModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* EDIT MODAL */}
      <Modal isOpen={isEditModalOpen} toggle={() => setIsEditModalOpen(false)}>
        <ModalHeader toggle={() => setIsEditModalOpen(false)}>Edit Category</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Main Category</label>
            <input
              type="text"
              className="form-control"
              value={editMainCategory}
              onChange={(e) => setEditMainCategory(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Sub Category</label>
            <input
              type="text"
              className="form-control"
              value={editSubCategory}
              onChange={(e) => setEditSubCategory(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              className="form-control"
              value={editDescription}
              onChange={(e) => setEditDescription(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Severity</label>
            <Select
              options={[
                { label: "Low", value: "low" },
                { label: "Medium", value: "medium" },
                { label: "High", value: "high" },
              ]}
              value={{ label: editSeverity, value: editSeverity }}
              onChange={(opt) => setEditSeverity(opt.value)}
            />
          </div>
          <div className="form-group">
            <label>Active?</label>
            <Select
              options={[
                { label: "Active", value: true },
                { label: "Inactive", value: false },
              ]}
              value={editIsActive ? { label: "Active", value: true } : { label: "Inactive", value: false }}
              onChange={(opt) => setEditIsActive(opt.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="warning" onClick={handleEditCategory}>
            Save Changes
          </Button>
          <Button color="secondary" onClick={() => setIsEditModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* DELETE CONFIRMATION */}
      <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(false)}>
        <ModalHeader toggle={() => setIsDeleteModalOpen(false)}>Confirm Delete</ModalHeader>
        <ModalBody>
          Are you sure you want to delete category <b>{deedToDelete?.main_category}</b>?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleDeleteCategory}>
            Delete
          </Button>
          <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default ListAmalanBurukPage;
